import { get, flatten, keyBy, mapValues, findIndex } from "lodash"

export default questions => {
  // Order Groups and connect them
  // Array of identifiers per QuestionPane. Each questionPane should route to the next one.
  let identifierOrder = questions.map(questionGroup => {
    if (questionGroup.identifier) {
      //Current block of question is a dedicated group, displayed together
      return [
        questionGroup.questions.map(({ question }) =>
          get(question, "identifier")
        ),
      ]
    }
    return questionGroup.questions.map(({ question }) => [
      get(question, "identifier"),
    ])
  })
  identifierOrder = flatten(identifierOrder)

  let showNavigationMap = flatten(
    questions.map(questionGroup => {
      if (questionGroup.identifier) {
        return questionGroup.questions.map(({ question }) => ({
          showNavigation: get(question, "showNavigation", true),
          identifier: get(question, "identifier"),
        }))
      }
      return questionGroup.questions.map(({ question }) => ({
        showNavigation: get(question, "showNavigation", true),
        identifier: get(question, "identifier"),
      }))
    })
  )
  showNavigationMap = keyBy(showNavigationMap, "identifier")
  showNavigationMap = mapValues(
    showNavigationMap,
    ({ showNavigation }) => showNavigation
  )

  return (state, { back, _identifier, _value }) => {
    const activeIdentifierGroup =
      identifierOrder[
        findIndex(
          identifierOrder,
          groupIdentifiers =>
            groupIdentifiers.indexOf(state.activeIdentifier) > -1
        )
      ]

    const showNavigation = activeIdentifierGroup.reduce(
      (navigationActive, identifier) => {
        return (
          navigationActive &&
          (showNavigationMap[identifier] === null
            ? true
            : showNavigationMap[identifier])
        )
      },
      true
    )

    return {
      ...state,
      navigationVisible:
        showNavigation === null || back ? true : showNavigation,
    }
  }
}
